import React from 'react';
import { useNavigate } from "react-router-dom";

import { Button, Form, Modal } from 'react-bootstrap';
import {IoIosArrowForward} from 'react-icons/io';

import '../EmailVerification.scss';

const CodeErrorModal = (props: any) => {

  const navigate = useNavigate();
  const goHome = (): void => {
    window.location.replace('https://motorsportgames.com/')
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      className='code-modal-container'
    >
      <img src="/ms_games_blk_red_neg_200x37-2.png" height="37" className="verify-logo-generic" />
      <Modal.Header className="code-modal-header msg-text">
        <Modal.Title id="contained-modal-title-vcenter" className="msg-text code-modal-title">
          Account Verification Error
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="code-modal-body msg-text">
        <div className="container msg-text">
          <div className="row msg-text">
            The server encountered an error while verifying your e-mail address. Please try again later.
          </div>
          <br></br>
          <div className="row msg-text">
            {props?.info?.message ?? "Unknown error"}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="code-modal-footer msg-text">
        <Button className="code-modal-submit-button msg-text"
          onClick={goHome}>
          <span>OK
            <IoIosArrowForward className="code-modal-submit-icon" size="0.75rem"/>
          </span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CodeErrorModal;
